<router-outlet />
@if (apiContext.isLoading()) {
  <div class="app-request-progress" role="status" aria-label="Carregando requisição"></div>
}
<app-toast-outlet />
<app-confirm-dialog-outlet />

@if (sessionRecovery.isReauthRequired()) {
  <div appDialogOverlay>
    <section appDialog aria-labelledby="session-expired-title" aria-describedby="session-expired-description">
      <h2 appDialogTitle id="session-expired-title">Sessão expirada</h2>
      <p appDialogDescription id="session-expired-description">
        Entre novamente para continuar usando o Automato com segurança.
      </p>

      <div class="mt-5 flex justify-end">
        <button appButton variant="primary" type="button" (click)="loginAgain()">
          Entrar novamente
        </button>
      </div>
    </section>
  </div>
}
